// Modules
import React from 'react';
import _ from 'lodash';

import { FormCard } from 'components/content-containers/cards';
import { Page, PageContent, PageHeader } from 'components/page';
import SVG from 'components/widgets/icons/svg';
import MfaDevice from 'services/data/mfa-device';
import MfaDeviceForm from './components/mfa-device-form';
import appHistory from 'app-history';


// Component
export default function MfaDeviceAdd() {
  const onSubmit = (values) => {
    const create = _.clone(values);

    return MfaDevice.create(create)
      .then(() => {
        appHistory.push('/mfa');
      });
  };

  return (
    <Page>
      <PageHeader title="Add MFA Device" />
      <PageContent className="bg-medium-blue-grey">
        <div className="form-summary flex flex-equal-children">
          <FormCard className="mfa-device-form">
            <div className="form-header">
              <SVG src="svg/cog.svg" className="cog" />
              <h5 className="form-title">Add MFA Device</h5>
            </div>
            <MfaDeviceForm onSubmit={onSubmit} />
          </FormCard>
        </div>
      </PageContent>
    </Page>
  );
}

